export default {
  ERROR_STARTING_RECORDING_DEVICES: 'error starting recording devices',
  // We're allowing Hippo to handle this specific error for now
  HIPPO_SCREEN_PERMISSION_DENIED_ERROR:
    'You must provide permission for screen recording',
};
